import { Flex } from 'antd'
import { PropsWithChildren } from 'react'

export const ContentWrapper = ({ children }: PropsWithChildren) => {
  return (
    <Flex vertical style={{ padding: 50 }} gap={20}>
      {children}
    </Flex>
  )
}
